import { BrowserRouter } from "react-router-dom";
import { PolarisVizProvider } from "@shopify/polaris-viz";
import { Provider as RollbarProvider, ErrorBoundary } from "@rollbar/react";
import { PostHogProvider } from "posthog-js/react";

import { GraphQLProvider, PolarisProvider } from "./components/providers";
import Routes from "./Routes";
import { Page } from "./Page";
import { rollbarConfig } from "./rollbar.config.js";

import { GlobalProvider } from "./context/GlobalContext";
import { UtmSetProvider } from "./context/UtmSetContext";
import { PlatformsProvider } from "./context/PlatformsContext";
import { SettingsProvider } from "./context/SettingsContext";

import "@shopify/polaris-viz/build/esm/styles.css";

const posthogOptions = {
  api_host: process.env.PUBLIC_POSTHOG_HOST,
};

export default function App() {
  const pages = import.meta.glob("./pages/**/!(*.test.[jt]sx)*.([jt]sx)", { eager: true });

  return (
    <RollbarProvider config={rollbarConfig}>
      <ErrorBoundary>
        <PostHogProvider apiKey={process.env.PUBLIC_POSTHOG_KEY} options={posthogOptions}>
          <PolarisVizProvider>
            <PolarisProvider>
              <BrowserRouter>
                <GraphQLProvider>
                  <GlobalProvider>
                    <PlatformsProvider>
                      <UtmSetProvider>
                        <SettingsProvider>
                          <Page>
                            <Routes pages={pages} />
                          </Page>
                        </SettingsProvider>
                      </UtmSetProvider>
                  </PlatformsProvider>
                  </GlobalProvider>
                </GraphQLProvider>
              </BrowserRouter>
            </PolarisProvider>
          </PolarisVizProvider>
        </PostHogProvider>
      </ErrorBoundary>
    </RollbarProvider>
  );
}
